import api from '@pray/shared/utils/api';
import type { ImportStatusResponse } from './types';
type Props = { artistId: string; catalogId: string; importId: string };
export async function getImportStatus({ artistId, catalogId, importId }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Unwrap the backend envelope ({ responded_at, object, data }) one level — see getCatalogs.ts.
  const res = await api.executeGetRequest<{ data: ImportStatusResponse }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/imports/${importId}`);
  return res.data.data;
}
